import { render, staticRenderFns } from "./columnViewData.vue?vue&type=template&id=1aa0b93e&scoped=true"
import script from "./columnViewData.vue?vue&type=script&lang=js"
export * from "./columnViewData.vue?vue&type=script&lang=js"
import style0 from "./columnViewData.vue?vue&type=style&index=0&id=1aa0b93e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0b93e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa0b93e')) {
      api.createRecord('1aa0b93e', component.options)
    } else {
      api.reload('1aa0b93e', component.options)
    }
    module.hot.accept("./columnViewData.vue?vue&type=template&id=1aa0b93e&scoped=true", function () {
      api.rerender('1aa0b93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/import/general/components/columnViewData.vue"
export default component.exports